// import { scroller } from 'react-scroll';

import filterProductScopedSections from '../../services/content/filter-product-scoped-sections';
import debug from '../../services/debug';
import {
    REMOVE_ALL_UNSCOPED_SECTIONS_REQUESTED,
    REMOVE_ALL_UNSCOPED_SECTIONS_COMPLETED,
    REMOVE_ALL_UNSCOPED_SECTIONS_ERROR,
} from './types';

const removeAllUnscopedSectionsAction = async () => async (dispatch, getState) => {
    dispatch({
        type: REMOVE_ALL_UNSCOPED_SECTIONS_REQUESTED,
    });
    try {
        const {
            selectedsections,
            selectproduct,
            content,
        } = getState();

        const payload = filterProductScopedSections(
            selectproduct.get('selectproduct'),
            content.get('content').reasonswhy,
            selectedsections.get('selectedsections'),
        );
        debug('removeAllUnscopedSectionsAction', payload);
        return dispatch({
            type: REMOVE_ALL_UNSCOPED_SECTIONS_COMPLETED,
            payload,
        });
    } catch (err) {
        return dispatch({
            type: REMOVE_ALL_UNSCOPED_SECTIONS_ERROR,
            payload: err,
        });
    }
};

export default removeAllUnscopedSectionsAction;
